import React from 'react';

import { GameClickProps, GameTileProps } from '@/components/modular-grid/types';
import { CurrencyCodeType } from '@/types/currency';
import { JackpotBetAmountsType } from '@/types/jackpotTypes';

import styles from './JackpotBetWidget.module.scss';
import JackpotBetWidgetGameList from './JackpotBetWidgetGameList';
import JackpotBetWidgetHeader from './JackpotBetWidgetHeader';
import JackpotBetWidgetType from './JackpotBetWidgetType';

export interface JackpotBetWidgetPropTypes {
  winners_today_text: string;
  wins_today_text: string;
  games_carousel_text: string;
  prize_labels: Record<string, string>;
  logo: {
    url: string;
  };
  background: {
    url: string;
  };
  carousel_speed: number;
  games: GameTileProps[];
  winsToday?: number;
  winnersToday?: number;
  jpAmounts?: JackpotBetAmountsType[];
  currencyCode?: CurrencyCodeType;
  onGameTileClick: (game: GameClickProps) => void;
  onGameTileInfoClick: (game: GameClickProps, path: string) => void;
}

const JackpotBetWidget: React.FC<JackpotBetWidgetPropTypes> = ({
  winners_today_text,
  wins_today_text,
  games_carousel_text,
  prize_labels,
  logo,
  background,
  carousel_speed,
  games,
  winsToday = 0,
  winnersToday = 0,
  jpAmounts = [],
  currencyCode,
  onGameTileClick = () => {},
  onGameTileInfoClick = () => {},
}) => {
  if (!jpAmounts.length || !games.length) return null;

  return (
    <div data-testid="jackpot-bet-wrapper" className={styles.wrapper}>
      <div
        data-testid="jackpot-bet-widget"
        className={styles.widget}
        data-test-id="jackpot-bet-widget"
        style={{ backgroundImage: `url(${background.url})` }}
      >
        <JackpotBetWidgetHeader
          winnersText={winners_today_text}
          winnersToday={winnersToday}
          winsText={wins_today_text}
          winsToday={winsToday}
          logo={logo}
          currencyCode={currencyCode}
        />

        <div className={styles.widgetBottom}>
          <JackpotBetWidgetType
            jpAmounts={jpAmounts}
            prize_labels={prize_labels}
            currencyCode={currencyCode}
          />
          <JackpotBetWidgetGameList
            onGameTileClick={onGameTileClick}
            onGameTileInfoClick={onGameTileInfoClick}
            title={games_carousel_text}
            games={games}
            carouselSpeed={carousel_speed}
          />
        </div>
      </div>
    </div>
  );
};

export default JackpotBetWidget;
